import React, { useState } from 'react';
import { BrazierType, BrazierIntensity } from './types';
import { Braziers } from './Braziers';
import { SeveringOfYokes } from './SeveringOfYokes';

export const LivingIronForge: React.FC = () => {
  const [intensities, setIntensities] = useState<Record<BrazierType, BrazierIntensity>>({
    iron: 'kindled',
    bronze: 'extinguished',
    basalt: 'extinguished'
  });

  const handleToggleBrazier = (type: BrazierType) => {
    setIntensities(prev => {
      const current = prev[type];
      const next: BrazierIntensity = 
        current === 'extinguished' ? 'kindled' :
        current === 'kindled' ? 'blazing' : 'extinguished';
      return { ...prev, [type]: next };
    });
  };

  return (
    <div className="space-y-12 animate-fade-in" id="living-iron-forge-container">
      {/* Header with Ritual Candles Flanking */}
      <div className="relative overflow-hidden rounded-lg border border-iron-dark bg-gradient-to-r from-obsidian-surface via-obsidian-deep to-obsidian-surface p-6 sm:p-8 shadow-chthonic">
        <div className="absolute right-4 -top-6 w-32 h-44 sm:w-40 sm:h-52 opacity-30 pointer-events-none hidden sm:block">
          <img src="/assets/forge/altar_candles.png" alt="Black Altar Candles" className="w-full h-full object-contain filter drop-shadow-[0_0_20px_rgba(230,197,110,0.3)]" />
        </div>
        <div className="relative z-10 space-y-2 max-w-2xl">
          <div className="inline-flex items-center gap-2 rounded border border-bronze-dark/80 bg-obsidian-deep/90 px-3 py-1 text-[11px] font-title tracking-[0.2em] text-gold-ancient uppercase">
            <span>CAMĪNUS FERRI</span>
            <span>•</span>
            <span>RITUAL ALTAR & FORGE</span>
          </div>
          <h1 className="font-display text-3xl sm:text-4xl text-parchment-light uppercase tracking-wider">
            The Living Iron Forge
          </h1>
          <p className="text-xs sm:text-sm text-parchment-dim leading-relaxed font-serif italic">
            The Three Mineral Braziers of Earth and the Cold Anvil of Severance: an operative alchemical temple for burning away servile attachments and transmuting spiritual weakness into sovereign tempered steel.
          </p>
        </div>
      </div>

      {/* Part 1: The Three Braziers of Earth */}
      <section aria-labelledby="braziers-heading">
        <h2 id="braziers-heading" className="sr-only">The Three Braziers of Earth</h2>
        <Braziers
          intensities={intensities}
          onToggleBrazier={handleToggleBrazier}
        />
      </section>

      {/* Part 2: Severing of Yokes Ritual */}
      <section aria-labelledby="severing-heading">
        <h2 id="severing-heading" className="sr-only">Severing of Yokes Ritual</h2>
        <SeveringOfYokes />
      </section>
    </div>
  );
};

export default LivingIronForge;
